// ------------------------------------
// Salva o checkout
// ------------------------------------

// Campos chaves que ao serem alterados, acionam a ação para salvar o checkout
const $inputSaves = $('[data-input-save]');

// Variáveis
const $form = $('#form-checkout');
const $infos = $('[data-checkout-infos]');
const url = urlBase + 'core/acoes/checkout/checkout.php';
const type = $form.attr('method');
const $btnOrderCreate = $('.co-btn-buy .btn-buy');
const btnOrderCreateText = $btnOrderCreate.data('text');
let cartInfos = $infosBase.data('cart-infos');

let data;
let reqAjaxSave = null;

// Desabilita o botão principal
function disableOrderBtn() {
  $btnOrderCreate.prop('disabled', true).addClass('btn-loader').text('Aguarde');
}

// Habilita o botão principal
function enableOrderBtn() {
  $btnOrderCreate.prop('disabled', false).removeClass('btn-loader').html(btnOrderCreateText);
}

// Ao alterar o campo
$inputSaves.on('change', function () {
  console.log('Save from: inputs');
  saveCheckout();
});

// Salva o checkout
function saveCheckout(acao = 'save', extraData = {}, callback = null, loader = false) {
  if (!previewMode) {
    $form.submit(function () {
      return false;
    });
    data = new FormData($form[0]);
    data.append('acao', acao);
    data.append('seo_url', baseLanding);
    if (Object.keys(extraData).length > 0) {
      for (let itemExtra in extraData) {
        data.append(itemExtra, extraData[itemExtra]);
      }
    }
    if (reqAjaxSave != null) {
      reqAjaxSave.abort();
    }
    let $loader = loader;
    if ($loader && typeof $loader === 'string') {
      $loader = $(loader);
    }
    if ($loader && $loader.length > 0) $loader.show();
    disableOrderBtn();
    // Correção para impedir que salve sem a forma de envio
    if ($('.shipping_ways').length) {
      let curShippingWay = $('.shipping_ways input:checked').val();
      if (!curShippingWay && (getOption('shipping_way') || $('.shipping_ways').data('value'))) {
        curShippingWay = getOption('shipping_way') || $('.shipping_ways').data('value');
        data.append('shipping_way', curShippingWay);
      }
    }
    reqAjaxSave = $.ajax({
      url: url,
      type: type,
      data: data,
      contentType: false,
      cache: false,
      processData: false,
    })
      .done(function (result) {
        //console.log(result);
        try {
          result = JSON.parse(result);
          if (result.ac_contact_id != '') {
            $('#ac_contact_id').val(result.ac_contact_id);
          }
          if (result.status === 'success') {
            console.log('Checkout salvo com sucesso.');
            if (callback) {
              if (acao == 'order_bump_insert') {
                callback(result);
              } else {
                callback();
              }
            }
          } else {
            console.log(result);
            console.log('Não foi possível salvar o checkout (1).');
          }
        } catch (error) {
          console.log(result);
          console.log('Não foi possível salvar o checkout (2).');
        }
        if ($loader && $loader.length > 0) $loader.hide();
        $('.shipping-quantity-loader').hide();
        enableOrderBtn();
      })
      .fail(function (result) {
        if (result.statusText !== 'abort') {
          console.log(result.statusText);
          console.log('Não foi possível salvar o checkout.');
        }
        if ($loader && $loader.length > 0) $loader.hide();
        enableOrderBtn();
      });
  }
}

// Popula o formulário
function populaForm(checkout) {
  const ignoredFields = ['cart_token', 'acao'];
  for (let row in checkout) {
    if (ignoredFields.indexOf(row) !== -1) {
      continue;
    }
    const $input = $form.find(`[name="${row}"]`);
    if ($input.length > 0) {
      // Checkbox e radios
      if ($input.attr('type') == 'checkbox' || $input.attr('type') == 'radio') {
        $input.prop('checked', false);
        $form.find(`[name="${row}"][value="${checkout[row]}"]`).prop('checked', true);
        if ($input.attr('type') == 'radio') {
          $form.find(`[name="${row}"][value="${checkout[row]}"]`).click();
        }
      }
      // Campos padrões
      else {
        $input.val(checkout[row]);
      }
      //$input.trigger('change');
      $input.trigger('fl-checkval');
    }
  }
}

// ------------------------------------
// Copia o nome para o destinatário
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $inputName = $('#co-name');
  const $inputRecipient = $('#co-recipient');

  // Ao digitar o nome
  if ($inputRecipient.val() == '') {
    $inputName.on('input', function () {
      $inputRecipient.val($inputName.val()).trigger('fl-checkval').parsley().validate();
    });
  }
})();

// ------------------------------------
// Altera o tipo de cadastro (CPF/CNPJ)
// ------------------------------------
(function () {
  'use strict';
  $('.doc-type-selector').on('change', function () {
    handleDocType();
  });
  function handleDocType() {
    let docType = $('.doc-type-selector:checked').val();
    if (previewMode) {
      docType = $('.doc-type-toggle').data('editor-default');
    }
    if (!docType) {
      docType = $('.doc-type-selector').val();
    }
    docType = docType.toUpperCase();
    const $inputsCPF = $('.form-group-cpf');
    const $inputsCNPJ = $('.form-group-cnpj');
    $('#co-doc-type').val(docType);
    if ($('[data-checkout="docType"]').length) {
      $('[data-checkout="docType"]').val(docType);
    }
    if (docType === 'CPF') {
      $('.v-doc-type-lbl').text('CPF:');
      $('.form-group-name').find('label').text('Nome completo');
      $('.form-group-name').find('input').attr('data-parsley-fullname', 'true');
      $('.form-group-name').find('input').data('placeholder', 'Ex: João da Silva');
      $('.form-group-doc').find('label').text('CPF');
      $('.form-group-doc')
        .find('input')
        .removeAttr('data-parsley-cnpj')
        .attr('data-parsley-cpf', 'true')
        .removeClass('cnpj')
        .addClass('cpf')
        .data('placeholder', '000.000.000-00');
      $inputsCNPJ.hide();
      //$inputsCNPJ.val('');
      $inputsCNPJ.find('input').prop('disabled', true);
      $inputsCNPJ.find('input[data-required]').prop('required', false);
      $inputsCPF.show();
      $inputsCPF.find('input').prop('disabled', false);
      $inputsCPF.find('input[data-required]').prop('required', true);
      //$inputsCPF.find('input').trigger('fl-checkval');
    } else if (docType === 'CNPJ') {
      $('.v-doc-type-lbl').text('CNPJ:');
      $('.form-group-name').find('label').text('Razão social');
      $('.form-group-name').find('input').removeAttr('data-parsley-fullname');
      $('.form-group-name').find('input').data('placeholder', 'Ex: João da Silva LTDA');
      $('.form-group-doc').find('label').text('CNPJ');
      $('.form-group-doc')
        .find('input')
        .removeAttr('data-parsley-cpf')
        .attr('data-parsley-cnpj', 'true')
        .removeClass('cpf')
        .addClass('cnpj')
        .data('placeholder', '00.000.000/0000-00');
      $inputsCPF.hide();
      //$inputsCPF.val('');
      $inputsCPF.find('input').prop('disabled', true);
      $inputsCPF.find('input[data-required]').prop('required', false);
      $inputsCNPJ.show();
      $inputsCNPJ.find('input').prop('disabled', false);
      $inputsCNPJ.find('input[data-required]').prop('required', true);
      //$inputsCNPJ.find('input').trigger('fl-checkval');
      handleInscEstadual();
    }
    $('.form-group-name').find('input').parsley().reset();
    $('.form-group-doc').find('input').parsley().reset();
    $inputsCPF.find('input').each(function () {
      $(this).parsley().reset();
    });
    $inputsCNPJ.find('input').each(function () {
      $(this).parsley().reset();
    });
    initInputsMask();
    verifyValidInputs();
  }
  if ($('.doc-type-selector').length) {
    handleDocType();
  }

  // Inscrição estadual
  $('#co-insc-estadual-isento').on('change', handleInscEstadual);
  function handleInscEstadual() {
    if ($('#co-insc-estadual-isento').is(':checked')) {
      $('#co-insc-estadual').prop('disabled', true).prop('readonly', true).prop('required', false).val('Isento');
    } else {
      $('#co-insc-estadual').prop('disabled', false).prop('readonly', false).prop('required', true).val('');
    }
    $('#co-insc-estadual').trigger('change');
    $('#co-insc-estadual').parsley().reset();
  }
})();

// ------------------------------------
// Copia o cpf para o cartão
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $inputCPF = $('#co-cpf');
  const $inputCardCPF = $('#co-card-cpf');

  // Ao digitar o CPF
  $inputCPF.on('input change', function () {
    if ($('#co-doc-type').val() === 'CPF') {
      if ($inputCardCPF.length > 0) {
        $inputCardCPF.val($inputCPF.val());
        $inputCardCPF.trigger('fl-checkval');
        $inputCardCPF.parsley().validate();
      }
      const docNumber = somenteNumeros($inputCPF.val());
      if ($('#docNumber').length > 0 && docNumber.length > 10) {
        $('#docNumber').val(docNumber).trigger('change');
      }
    }
  });
})();

// ------------------------------------
// Calcula os valores
// ------------------------------------
function calcCheckout() {
  // Variáveis
  const $subtotalView = $('.v-cart-subtotal');
  const $shippingDescView = $('.v-cart-shipping-desc');
  const $shippingValView = $('.v-cart-shipping-val');
  const $discountView = $('.v-cart-discount');
  const $discountDescView = $('.v-cart-discount-desc');
  const $discountTooltip = $discountDescView.find('i');
  const $discountValView = $('.v-cart-discount-val');
  const $totalView = $('.v-cart-total');
  const $customAmountWrp = $('.v-cart-custom');
  const $customAmountView = $('.v-cart-custom-val');

  // Valores
  let subtotal = 0;
  let subtotalShow = 0;
  let totalOrderbumps = 0;
  let discountCoupon = 0;
  let discountPayment = 0;
  let discountProgressive = 0;
  let discount = 0;
  let discountShow = 0;
  let discountDesc = '';
  let shipping = 0;
  let total = 0;
  let customAmount = 0;

  // Order Bump
  const orderBumpList = getOption('orderbump');
  if (orderBumpList) {
    totalOrderbumps = orderBumpList.reduce((sum, item) => sum + Number(item.value), 0);
  }

  // Customizações
  customAmount = calcTotalCustomsCheckout();
  customAmount > 0 ? $customAmountWrp.removeClass('d-none') : $customAmountWrp.addClass('d-none');
  $customAmountView.text('+ R$ ' + formatMoneyBR(customAmount));

  // Desconto progressivo
  if ($discountView.data('discount-prog')) {
    discountProgressive = Number($discountView.data('discount-prog'));
    discountShow = discountProgressive;
    discountDesc += '<p>Desconto progressivo: - R$ ' + formatMoneyBR(discountProgressive) + '</p>';
  }

  // Subtotal
  subtotal = calcSubtotalCheckout();
  subtotal += totalOrderbumps;
  subtotalShow = subtotal + discountProgressive;
  saveOption('subtotal', subtotal);
  $subtotalView.text('R$ ' + formatMoneyBR(subtotalShow));

  // Frete
  let shippingWay = getOption('shipping_way');
  let shippingWayTitle = getOption('shipping_way_title');
  let shippingPrice = getOption('shipping_way_price');
  shippingWayTitle = shippingWayTitle ? '(' + shippingWayTitle + ')' : '';
  shipping = shippingPrice && shippingPrice !== 'undefined' ? Number(shippingPrice) : 0;
  let shippingView;
  if (shippingWay) {
    if (shipping > 0) {
      shippingView = 'R$ ' + formatMoneyBR(shipping);
    } else {
      shippingView = 'Grátis';
    }
  } else {
    shippingView = '-';
  }
  $shippingDescView.text(shippingWayTitle);
  $shippingValView.text(shippingView);

  // Desconto pagamento
  discountPayment = getOption('payment_discount') ? Number(getOption('payment_discount')) : 0;
  let paymentMethod = getOption('payment_method');
  let paymentTitle = getOption('payment_title');
  if (discountPayment > 0) {
    discountPayment = (discountPayment * subtotal) / 100;
    discount += discountPayment;
    discountShow += discountPayment;
    discountDesc += '<p>' + paymentTitle + ': - R$ ' + formatMoneyBR(discountPayment) + '</p>';
  }

  // Desconto cupom
  let coupounDesc = getOption('coupoun_desc');
  let coupounType = getOption('coupoun_type');
  let coupounVal = getOption('coupoun_val') ? Number(getOption('coupoun_val')) : 0;
  let coupounRestrictedProds = getOption('coupoun_restricted_prods') || [];
  let coupounRestrictedAmount = getOption('coupoun_restricted_amount') || 0;
  if (coupounVal > 0) {
    if (coupounType === 'percent') {
      // Aplica o desconto apenas em produtos específicos
      if (
        coupounRestrictedProds &&
        coupounRestrictedProds.length &&
        coupounRestrictedAmount &&
        coupounRestrictedAmount > 0
      ) {
        discountCoupon = (coupounVal * coupounRestrictedAmount) / 100;
      } else {
        discountCoupon = (coupounVal * subtotal) / 100;
      }
    } else if (coupounType === 'value') {
      discountCoupon = coupounVal;
    }
    discountDesc += '<p>Cupom (' + coupounDesc + '): - R$ ' + formatMoneyBR(discountCoupon) + '</p>';
  }

  // Desconto
  discount = discountPayment + discountCoupon;
  discountShow += discountCoupon;
  if (discountShow > 0) {
    $discountView.removeClass('d-none');
    $discountValView.text('- R$ ' + formatMoneyBR(discountShow));
    $discountTooltip.data('tippy-content', discountDesc);
    $discountTooltip[0]._tippy.setContent(discountDesc);
    //$discountTooltip[0]._tippy.show();
  } else {
    $discountView.addClass('d-none');
    $discountValView.text('- R$ 0,00');
    $discountTooltip[0]._tippy.setContent(discountDesc);
    //$discountTooltip[0]._tippy.hide();
  }

  // Total
  total = subtotal + shipping + customAmount - discount;
  saveOption('total', total);

  // Recarrega as parcelas
  $('#co-card-installments').trigger('change-amount');

  $totalView.text('R$ ' + formatMoneyBR(total));
}

// ------------------------------------
// Retorna uma informação
// ------------------------------------
function getOption(option) {
  if ($infos.data('checkout-infos') != '') {
    const infos = JSON.parse($infos.data('checkout-infos'));
    return infos[option];
  }
  return '';
}

// ------------------------------------
// Salva uma informação
// ------------------------------------
function saveOption(option, value) {
  let infos = {};
  if ($infos.data('checkout-infos') != '') {
    infos = JSON.parse($infos.data('checkout-infos'));
  }
  infos[option] = value;
  $infos.data('checkout-infos', JSON.stringify(infos));
}

// ------------------------------------
// Remove uma informação
// ------------------------------------
function remOption(option) {
  let infos = {};
  if ($infos.data('checkout-infos') != '') {
    infos = JSON.parse($infos.data('checkout-infos'));
  }
  delete infos[option];
  $infos.data('checkout-infos', JSON.stringify(infos));
}

// ------------------------------------
// Retorna o total do pedido
// ------------------------------------
function getTotalCheckout() {
  return getOption('total') ? Number(getOption('total')) : 0;
}

// ------------------------------------
// Calcula o total de customizações
// ------------------------------------
function calcTotalCustomsCheckout() {
  let totalCutoms = 0;
  $('.co-r-item[data-price-add]').each(function () {
    const $el = $(this);
    let priceAdd = $el.data('price-add') ? Number($el.data('price-add')) : 0;
    totalCutoms += priceAdd;
  });
  return totalCutoms;
}

// ------------------------------------
// Calcula o subtotal do pedido
// ------------------------------------
function calcSubtotalCheckout() {
  let subtotal = 0;
  $('.co-r-item[data-price]:not(.co-r-item-orderbump)').each(function () {
    const $el = $(this);
    const $priceView = $el.find('.co-r-item-price');
    let quantity;
    if ($el.find('.co-r-item-quantity-info').length) {
      quantity = parseInt($el.find('.co-r-item-quantity-info').data('qty'));
    } else {
      quantity = $el.find('.co-r-item-quantity input').val();
    }
    let priceUnit = $el.data('price') ? Number($el.data('price')) : 0;
    quantity = quantity ? Number(quantity) : 1;
    let subtotalItem = priceUnit * quantity;
    subtotal += subtotalItem;
    $priceView.html('R$ ' + formatMoneyBR(subtotalItem));
  });
  return subtotal;
}
